<template>
  <div >
  <div class="dashboard">
    <div class="search-bar">
      <el-input
        type="text"
        v-model="searchQuery"
        class="search-input"
        placeholder="请输入产品名称关键字"
        clearable
        @clear="handleClear"
      />
      <el-button size="large" @click="search(true)">搜索</el-button>
    </div>

    <div class="hot-tags">
      <div class="tag">
        <img src="@/assets/fire.png" alt="" />
        热门: {{ hotWord }}
      </div>
    </div>

    <div class="filter-container">
      <!-- 应用板块 -->
      <div class="filter-group">
        <div class="filter-title">应用板块</div>
        <div class="filter-items">
          <el-radio-group
            size="small"
            v-model="checkedApplicationAreas"
            @change="handleCheckedApplicationAreas"
          >
            <el-radio-button
              v-for="area in applicationSectors"
              :label="area"
              :key="area"
              class="custom-checkbox-button"
            >
              {{ area }}
            </el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <!-- 产品类型 -->
      <div class="filter-group">
        <div class="filter-title">产品类型</div>
        <div class="filter-items">
          <el-radio-group
            size="small"
            v-model="checkedProductTypes"
            @change="handleCheckedProductTypes"
          >
            <el-radio-button
              v-for="type in productTypes"
              :label="type"
              :key="type"
              class="custom-checkbox-button"
            >
              {{ type }}
            </el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <!-- 选择地区 -->
      <div class="filter-group">
        <div class="filter-title">选择地区</div>
        <div class="filter-items">
          <el-radio-group
            size="small"
            class="newgrpoup"
            v-model="checkedRegions"
            @change="handleCheckedRegions"
          >
            <el-radio-button
              v-for="region in regions"
              :label="region"
              :key="region"
              class="custom-checkbox-button"
            >
              {{ region }}
            </el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <div class="item_options" @click="clearAll">
        <img src="@/assets/deledate.png" alt="" />
        <span style="text-align: center; margin-left: 5px;">清除所有</span>
      </div>
    </div>

    <div class="card-list" v-if="data.length > 0">
      <el-row :gutter="20">
        <el-col :span="8" v-for="(item, index) in data" :key="item.id">
          <el-card shadow="hover" class="custom-card">
            <div class="card-content" @click="openDialogrong(index, item.id)">
              <div class="card-contents">
                <img
                  :src="productTypeImages[item.productType]"
                  class="newimg"
                  alt=""
                />

                <el-tooltip
                  :content="item.productName"
                  placement="top"
                  effect="dark"
                  :open-delay="500"
                  ><span class="card-title">
                    {{
                      item.productName.length > 17
                        ? item.productName.slice(0, 17) + "..."
                        : item.productName
                    }}</span
                  >
                </el-tooltip>
              </div>
              <div class="card-div">
                <p>产品类型：{{ item.productType }}</p>
                <p>行业：{{ item.applicationMinceArea }}</p>
                <p>产品介绍：{{ item.productDescriptions }}</p>
              </div>
              <p class="endp">更新日期：{{ item.updateTime }}</p>
              <p class="endmo">
                <img src="@/assets/img/wendang.png" alt="" class="newimgdes" />
                <el-link
                  style="z-index: 100; position: relative;"
                  type="primary"
                  >详情</el-link
                >
              </p>
              <p class="endm">
                <img src="@/assets/img/iears.png" alt="" class="newimgdes" />
                {{ item.showNum }}
              </p>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <div>
        <el-pagination
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :total="totalall"
          layout="prev, pager, next, jumper"
          @current-change="handlePageChange"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog title="数据集详情" :visible.sync="dialogVisibles" width="50%">
      <div class="details-content">
        <P>
          <span class="gray-text">产品名称：</span>
          <span class="black-text">{{ selectedItems.productName }}</span>
        </P>

        <p>
          <span class="gray-text">产品介绍：</span>
          <span class="black-text">{{ selectedItems.productDescription }}</span>
        </p>

        <p>
          <span class="gray-text">产品类型：</span>
          <span class="black-text">{{ selectedItems.productType }}</span>
        </p>
        <p>
          <span class="gray-text">应用行业：</span>
          <span class="black-text">{{
            selectedItems.applicationMinceArea
          }}</span>
        </p>
        <p>
          <span class="gray-text">供方公司：</span>
          <span class="black-text">{{ selectedItems.supplierName }}</span>
        </p>
        <p>
          <span class="gray-text">存储大小：</span>
          <span class="black-text">{{ selectedItems.storageSize }}MB</span>
        </p>
        <p>
          <span class="gray-text">覆盖范围：</span>
          <span class="black-text">{{ selectedItems.coverage }}</span>
        </p>
        <p>
          <span class="gray-text">更新频率：</span>
          <span class="black-text">{{ selectedItems.updateFrequency }}</span>
        </p>
      </div>
    </el-dialog>
    <logins />
    
  </div>
  <component :is="currentComponent[currentIndex]"></component>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import CoreItemOne from '../core_competence/CoreItemOne.vue';
export default {
  data() {
    return {
      productTypeImages: {
        数据集: require("@/assets/img/Vector.png"),
        数据服务: require("@/assets/img/serive.png"),
        数据应用: require("@/assets/img/import.png"),
        其他: require("@/assets/img/other.png"),
      },
      currentIndex: 0,
       currentComponent:[CoreItemOne,],
      encodeFactor: "u5Ak3Y6Vn2p8L9qZ",
      showDetailsFlags: false, // 控制详情显示
      selectedItems: {
        productName: "",
        productDescription: "",
        productType: "",
        applicationMinceArea: "",
      }, // 当前选中的详细信息
      hotWord: "", // 热门搜索词
      applicationAreas: [],
      checkedApplicationAreas: "全部",
      checkedApplication: [],
      checkAllApplication: false,
      isIndeterminateApplication: true,
      bigdata: [],
      // 产品类型数据
      productTypes: [],
      checkedProduct: [],
      checkedProductTypes: "全部",
      decryptedList: [],
      checkAllProduct: false,
      isIndeterminateProduct: true,
      dialogVisibles: false,
      // 地区数据
      totalall: 0,
      regions: [],
      checkedRegion: [],
      checkedRegions: "全部",
      checkAllRegion: false,
      isIndeterminateRegion: true,

      searchQuery: "",
      currentPage: 1,
      pageSize: 6,
      totalItems: 24,
      applicationSectors: [],

      data: [
        // 添加更多数据项...
        // { id: 6, title: '公共交通线路实时客流查询', productType: '数据应用', industry: '公共交通', description: '基于交通卡/码交易数据，可提供上海市域范围内地面公交和轮渡的线路实时客流统计数据。', updateDate: '2024-09-26', views: 21 },
      ],
    };
  },
  // computed: {
  //   paginatedData() {
  //     const start = (this.currentPage - 1) * this.pageSize;
  //     const end = start + this.pageSize;
  //     return this.data.slice(start, end);
  //   },
  // },

  methods: {
    decrypt(text, key) {
      try {
        const keyHex = CryptoJS.enc.Utf8.parse(key);
        const decrypted = CryptoJS.AES.decrypt(text, keyHex, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7,
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
      } catch (error) {
        console.error("解密失败:", error);
        return null;
      }
    },
    encrypt(txt) {
      var key = CryptoJS.enc.Utf8.parse(this.encodeFactor);
      var srcs = CryptoJS.enc.Utf8.parse(txt);
      var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      return encrypted.toString();
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.search(false);
      //console.log("当前页:", page);
    },
    async openDialogrong(index, id) {
      const token = localStorage.getItem("token");
      // //console.log(token);

      if (token == null) {
        this.showDetailsFlags = false;
        this.showDetailsFlags = true;
        this.$store.commit("setDialogVisible", true);
      } else {
        this.showDetailsFlags = false;
        this.dialogVisibles = true;
        //console.log(index,id);
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
        try {
          // 使用 axios 发起 GET 请求，并传递参数
          const res = await this.axios.get(
            `https://www.hittik.com/zntop/top/updateShowNum?id=${id}`, // 将 id 作为查询参数传递

            config
          );

          // 处理响应数据
          this.data[index].showNum++;
          //console.log( res.data);
        } catch (error) {
          // 处理错误
          console.error("请求失败:", error);
        }
        this.selectedItems = this.data[index];
        // this.selectedItems = this.items[index];
        // this.$nextTick(() => {
        // this.initCharts();
        // });
      }
    },
    async getCardListData() {
      
      this.$api
        .getSection({
          parentId: 0,
        })
        .then((responses) => {
          console.log(responses, );
this.bigdata = responses;
      const newsList = responses;
      const hottt = responses.hotWord
        .map((item) => item.hotWordName) // 提取 hotWordName
        .filter((name) => name) // 过滤掉空字符串
        .join(" "); // 用空格拼接
      //console.log(hottt);
      this.hotWord = hottt;

      const processItems = (list, property, targetArray) => {
        list.forEach((item) => {
          if (item[property]) {
            targetArray.push(item[property]);
          }
        });
      };

      // 使用通用函数处理不同列表
      processItems(newsList.area, "districtName", this.regions);
      processItems(newsList.section, "fieldName", this.applicationSectors);
      processItems(newsList.productType, "productTypeName", this.productTypes);

        });
      const res = await this.axios.get(
        "https://www.hittik.com/zntop/top/getSection?parentId=0"
      );

      
      //console.log(this.regions);
    },
    handleSelect(type, value) {
      //console.log(`Selected ${type}:`, value);
    },
    async updateHotWord(name) {
      try {
        // 构造请求 URL
        const token = localStorage.getItem("token");
        let config = {};
        if (token) {
          config = {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          };
        }
        const url = `https://www.hittik.com/zntop/top/updateHotWord?name=${name}`;

        // 发起 GET 请求
        const response = await this.axios.get(url, config);

        // 处理响应数据
        //console.log(response.data);

        //console.log(response.data);
      } catch (error) {
        // 处理错误
        console.error("请求失败:", error);
      }
    },

    search(nowrap) {
      if (nowrap) {
        this.currentPage = 1;
        this.$message({
          message: "查询成功",
          type: "success", // 可选类型：success、warning、info、error
        });
      } else {
      }
      //console.log(this.checkedApplicationAreas);
      this.updateHotWord(this.searchQuery);
      let prodectIds = []; // 新数组，用于存放符合条件的 id
      let areaIds = []; // 新数组，用于存放符合条件的 id
      let setionIds = []; // 新数组，用于存放符合条件的 id
      this.bigdata.productType.forEach((item) => {
        if (this.checkedProductTypes.includes(item.productTypeName)) {
          prodectIds.push(item.id);
        }
      });
      this.bigdata.area.forEach((item) => {
        if (this.checkedRegions.includes(item.districtName)) {
          areaIds.push(item.id);
        }
      });
      this.bigdata.section.forEach((item) => {
        if (this.checkedApplicationAreas.includes(item.fieldName)) {
          setionIds.push(item.fieldName);
        }
      });

      let formdata = {
        name: this.encrypt(this.searchQuery),
        areaName: this.encrypt(areaIds[0]),
        productName: this.encrypt(prodectIds[0]),
        sectionName: this.encrypt(setionIds[0]),
        pageNum: this.currentPage,
        pageSize: 6,
        // 'productName': this.checkedProductTypes,
      };
      // var caddd= this.decrypt(formdata.productName);
      //       //console.log(caddd);
      const token = localStorage.getItem("token");
      let config = {};
      if (token) {
        config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      }

      this.$api.getDataProduct(formdata).then((response) => {
        if (response) {
         const encryptedList = response.list;
          //console.log("Success:", encryptedList);
          this.data = []; // 重置解密列表
          for (let i = 0; i < encryptedList.length; i++) {
            const decryptedItem = this.decrypt(
              encryptedList[i],
              this.encodeFactor
            );
            if (decryptedItem !== null) {
              this.data.push(JSON.parse(decryptedItem));
            } else {
              //console.log(`第 ${i} 个元素解密失败`);
            }
          }

          if (this.data.length > 0) {
            this.totalall = this.data[0].titleNum;
            //console.log(this.decryptedList,'this.decryptedList',this.data);

            this.data.forEach((item) => {
              if (item.productDescription.length > 80) {
                item.productDescriptions =
                  item.productDescription.slice(0, 80) + "...";
              } else {
                item.productDescriptions = item.productDescription;
              }
            });

            const idArray = this.data.map((item) => item.id);

           this.$api.getBrowse(idArray).then((response) => {
        if (response) {

          this.consumptionVisible = true;
          let needdata = response.list;

          this.total = response.total;
          this.tableDataxiao = needdata;

            let add = response.data;
              this.data.forEach((dataItem) => {
                const addItem = add.find(
                  (addEntry) => addEntry.productId === dataItem.id
                );

                // 如果找到匹配项，将add中的showNum赋值给this.data中的showNum
                if (addItem) {
                  dataItem.showNum = addItem.showNum;
                }
                console.log(response.data.data, "this.data");
              });
            
        }else {
            this.totalall = 0;
            this.$message({
              message: "查询结果为空！",
              type: "warning", // 可选类型：success、warning、info、error
            });
          }
      });
    }
        }
      });
      // const url = "https://www.hittik.com/zntop/top/getDataProduct";
      // // const url = "http://123.60.38.210:9205/top/getDataProduct";
      // this.axios
      //   .post(url, formdata, config)
      //   .then((response) => {


    },
    selectFilter(type, value) {
      //console.log(`筛选 ${type}: ${value}`);
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    handleCheckAllApplication(val) {
      this.checkedApplicationAreas = val ? this.applicationSectors.slice() : [];
      this.isIndeterminateApplication = false;
    },
    handleCheckedApplicationAreas(value) {
      const checkedCount = value.length;
      this.checkAllApplication =
        checkedCount === this.applicationSectors.length;
      this.isIndeterminateApplication =
        checkedCount > 0 && checkedCount < this.applicationSectors.length;
      this.currentPage = 1;
      this.search(false);
    },

    // 产品类型全选逻辑
    handleCheckAllProduct(val) {
      this.checkedProductTypes = val ? this.productTypes.slice() : [];
      this.isIndeterminateProduct = false;
    },
    handleCheckedProductTypes(value) {
      const checkedCount = value.length;
      this.checkAllProduct = checkedCount === this.productTypes.length;
      this.isIndeterminateProduct =
        checkedCount > 0 && checkedCount < this.productTypes.length;
      this.currentPage = 1;
      this.search(false);
    },

    // 地区全选逻辑
    handleCheckAllRegion(val) {
      this.checkedRegions = val ? this.regions.slice() : [];
      this.isIndeterminateRegion = false;
    },
    handleCheckedRegions(value) {
      const checkedCount = value.length;
      this.checkAllRegion = checkedCount === this.regions.length;
      this.isIndeterminateRegion =
        checkedCount > 0 && checkedCount < this.regions.length;
      this.currentPage = 1;
      this.search(false);
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    // 全清按钮逻辑
    clearAll() {
      this.checkAllApplication = false;
      this.checkedApplicationAreas = "全部";
      this.isIndeterminateApplication = false;

      this.checkAllProduct = false;
      this.checkedProductTypes = "全部";
      this.isIndeterminateProduct = false;

      this.checkAllRegion = false;
      this.checkedRegions = "全部";
      this.searchQuery = "";
      this.isIndeterminateRegion = false;
      this.currentPage = 1;
      this.search(false);
    },
    handleClear() {
      this.searchQuery = "";
    },
  },

  async mounted() {
     
    await this.getCardListData();
setTimeout(() => {
   this.search(false);
}, 500);
  
  },
};
</script>

<style scoped>
.dashboard {
  padding: 90px 200px 20px 200px;
}
.search-bar {
  display: flex;

  padding: 10px 5px 52px 10px;
  background: linear-gradient(180deg, #edf7ff 0%, #f5faff 100%);
}
.search-bar input {
  flex: 1;
  padding: 8px;
  margin-right: 10px;
}
.search-bar button {
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  height: 44px;
  width: 90px;
  margin-top: 7px;
  margin-right: 20px;
}
.hot-tags {
  margin-bottom: 10px;
  margin-top: -58px;
}
.tag {
  color: #74aeec;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  padding: 15px;
}
.filter-group {
  padding: 5px;
  border-radius: 8px;
  margin-bottom: 5px;
}

.newgrpoup {
  display: contents;
}
.filter-group h3 {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;

  color: #809cba;
  /* background: #809CBA; */
}

.el-checkbox {
  margin: 5px 0;
}

.el-checkbox.is-checked .el-checkbox__label {
  color: #409eff;
  font-weight: bold;
}
.item_options {
  position: absolute;
  display: flex;
  top: 595px;
  right: 225px;
}
.item_optionm {
  position: absolute;
  display: flex;
  top: 582px;
  right: 350px;
}

.item_optionm button {
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  height: 44px;
  width: 90px;
}

.filters {
  margin-bottom: 20px;
}
.filter-section {
  margin-bottom: 10px;
}
.filter-title {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;

  margin-bottom: 10px;

  color: #809cba;
}
.filter-items {
  display: flex;
  flex-wrap: wrap;
}
.filter-item {
  margin-right: 10px;
  margin-bottom: 5px;
  cursor: pointer;
}
.filter-item:hover {
  text-decoration: underline;
}
.content {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.custom-checkbox-button {
  margin: 0 5px; /* 按钮之间的间隔 */
  border: none; /* 去除边框 */
  border-radius: 5px; /* 圆角效果 */
  margin-bottom: 5px;
}
.card-content P {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #989898;
}

.custom-card {
  /* position: relative; */
  padding: 20px;
  /* width: 90%; */
  /* height: 90%; */
  height: 300px;
  margin-bottom: 10px;
}
.newimgdes {
  width: 20px;
  height: 20px;
  margin-right: 5px;
  margin-top: 2px;
}

/* 自定义非激活状态下文字的颜色 */
::v-deep .el-radio-button__inner {
  /* background-color: rgba(8, 18, 43, 0.5); */
  background-color: none !important;
  border: none !important;
}
::v-deep.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  border-radius: 5px !important; /* 圆角效果 */
}
.card {
  width: 300px;
  border: 1px solid #ddd;
  padding: 15px;
  border-radius: 5px;
}
.search-input {
  width: 1512px;
  padding: 10px;
}

.endp {
  position: absolute;
  bottom: 0;
  left: 0;
  margin: 0; /* 去掉默认的 margin */
}
.endm {
  position: absolute;
  bottom: 0;
  display: flex;
  right: 0;
  margin: 0; /* 去掉默认的 margin */
}
.endmo {
  position: absolute;
  bottom: 0;
  display: flex;
  right: 84px;
  margin: 0; /* 去掉默认的 margin */
}
.card h3 {
  margin-top: 0;
}
.meta {
  margin-top: 10px;
  color: #666;
  font-size: 12px;
}
.pagination {
  margin-top: 20px;
  margin-left: 650px;
  display: flex;
  align-items: center;
}
.pagination button {
  margin-right: 10px;
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
}
.card-div {
  background: #f6f6f6;
  padding: 0.52083vw;
  /* width: 50px; */
  height: 165px;
  overflow: auto;
}
.details-content p {
  font-size: 16px;
  margin: 10px 0;
}
.pagination span {
  margin-right: 10px;
}
.filter-container {
  padding: 20px;
  margin-bottom: 10px;
  border: 2px solid #d2dadf;
  border-radius: 5px;
  padding-bottom: 5px;
}

.el-card__body {
  overflow-y: scroll;
  height: 300px;
}

.card-title {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0%;
  margin-left: 5px;
  color: #333333;
}
::v-deep .el-pagination {
  display: flex;
  justify-content: center;
}
.newimg {
  width: 28px;
  height: 28px;
  padding: 2px;
}
.card-contents {
  display: flex;
  flex-direction: row;
}
.card-content {
  margin-bottom: 20px;

  overflow-y: auto;
  height: 250px;
  position: relative; /* 设置为相对定位 */
}

.filter-items {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.filter-button {
  padding: 8px 15px;

  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.filter-button.active {
  background-color: #409eff;
  color: #ffffff;
  border-color: #409eff;
}

/* .el-col {
  min-width: calc(33.33% - 20px); 
  flex: 1 0 calc(33.33% - 20px); 
}
.el-card {
  height: 100%; 
  min-height: 220px; 
  display: flex;
  flex-direction: column;
} */
.card-list {
  width: 100%;
  height: 30%;
}
</style>
